export default __webpack_public_path__ + "static/media/image-work-team-w@3x.9a160b0a.webp";